/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_S1_TitleInputs */

const en_mk_ctrl_s1_title = /** @type {(inputs: Mk_Ctrl_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent-readiness score`)
};

const id_mk_ctrl_s1_title = /** @type {(inputs: Mk_Ctrl_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor kesiapan agent`)
};

/**
* | output |
* | --- |
* | "Agent-readiness score" |
*
* @param {Mk_Ctrl_S1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_s1_title = /** @type {((inputs?: Mk_Ctrl_S1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_S1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_s1_title(inputs)
	return en_mk_ctrl_s1_title(inputs)
});